<template>
  <button
    class="btn btn-sm"
    :class="vClass"
    :title="$t(vTitle)"
    :style="{ backgroundColor: backgroundColor, color: color }"
    @click="onClick"
    v-b-tooltip
  >
    <div v-if="routerLink">
      <router-link :to="routerLink">
        <fa v-if="vFaClass" :fa-class="vFaClass" />

        <span v-if="text">{{ $t(text) }}</span>
      </router-link>
    </div>

    <div v-else>
      <fa v-if="vFaClass" :fa-class="vFaClass" />

      <span v-if="text">{{ $t(text) }}</span>
    </div>
  </button>
</template>

<script>
import fa from "@/components/global/icon/fontAwesome";
import formatter from "@/components/global/mixins/formatterMethods";
import buttons from "@/components/frontoffice/mixins/buttons";
import { status } from "@/utils/bookingStatus";

export default {
  components: {
    fa,
  },

  props: {
    defaultState: String,
    title: String,
    faClass: String,
    id: Number,
    historyTable: {
      type: Boolean,
      default: false,
    },
    callback: {
      type: Function,
      default: null,
    },
    bookingStatus: Number,
  },

  mixins: [formatter, buttons],

  data() {
    return {
      text: null,
      vFaClass: this.faClass,
      vTitle: this.title,
      color: null,
      backgroundColor: null,
      routerLink: null,
      vClass: null,
    };
  },

  created() {
    if (this.defaultState) this.updateData();
  },

  mounted() {
    // In case this.defaultState is overriden for a prop specifically
    for (let i in this.$props) {
      if (this.$props.hasOwnProperty(i)) {
        if (this.$props[i] !== undefined) {
          this["v" + this.formatToUCFirst(i)] = this.$props[i];
        }
      }
    }
  },

  methods: {
    onClick() {
      if (this.callback === null) this.$emit("click");
      else this.callback(this.id, this.defaultState);
    },

    updateData() {
      if (Object.keys(this.buttons).indexOf(this.defaultState) !== -1) {
        if (!this.buttons[this.defaultState].faOnSelectOnly)
          this.vFaClass = this.buttons[this.defaultState].faClass;
        this.text = this.buttons[this.defaultState].text;
        this.vTitle = this.buttons[this.defaultState].title;
        this.color = this.buttons[this.defaultState].color;
        this.backgroundColor = this.buttons[this.defaultState].backgroundColor;
      }

      if (this.id !== null) {
        let name = null;

        switch (this.defaultState) {
          case "allow":
            if (
              this.bookingStatus === status.WAITING_FOR_MANAGER_POST_VALIDATION
            )
              this.vTitle = "_validate";
            break;
          case "edit":
            if (this.bookingStatus === status.UNFINISHED_OFFLINE_BOOKING) {
              name = "offline_booking_edit";
            } else {
              name = "home_booking_edit";
            }
            break;
          case "duplicate":
            name = "home_booking_duplicate";
            break;
          case "show":
            name = "home_booking_show";
            if (this.historyTable) {
              this.vClass = "";
              this.vFaClass = "";
              this.text = this.$t("_details");
            }
            break;
          case "contactBBA":
          case "giveOpinion":
            name = "home_message_create";
            this.vClass = "";
            let text = "";

            switch (this.defaultState) {
              case "contactBBA":
                text = "booking.contact_bba";
                break;
              case "giveOpinion":
                text = "booking.your_opinion";
                break;
            }

            this.text = this.$t(text);
            break;
        }

        if (name !== null) {
          this.routerLink = {
            name: name,
            params: {
              id: this.id,
            },
          };
        }
      }
    },
  },

  watch: {
    id() {
      this.updateData();
    },
  },
};
</script>
